import { createFileRoute } from '@tanstack/react-router'
import { ToolPage } from '@/components/tool-page/tool-page'
import { toolHead } from '@/components/tool-page/tool-head'
import { DomainTool } from '@/components/tool-page/domain-tool'
import { isCuratedApexDomain } from '@/lib/popular-sites'
import { domainPageContent, safeDomain } from '@/lib/tool-content'

const PARENT = { name: 'Domain Expiry Checker', path: '/tools/domain-expiry-checker' }

export const Route = createFileRoute('/_site/tools/domain-expiry-checker_/$domain')({
  component: DomainExpiryDomainPage,
  // One indexing rule: a per-domain page is indexable only for a domain on the curated list
  // (registrable domains only: a registry has no record for a subdomain).
  head: ({ params }) => {
    const d = safeDomain(params.domain)
    return toolHead(domainPageContent('domain-expiry-checker', params.domain), { noindex: !(d && isCuratedApexDomain(d)), parent: PARENT })
  },
})

function DomainExpiryDomainPage() {
  const { domain } = Route.useParams()
  const content = domainPageContent('domain-expiry-checker', domain)
  return (
    <ToolPage content={content} parent={PARENT}>
      <DomainTool content={content} variant="expiry" initialDomain={safeDomain(domain) ?? ''} autoRun />
    </ToolPage>
  )
}
